module.exports = __webpack_public_path__ + "static/media/install-3.3d11fe85.png";